import { createApp } from 'vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import App from './App.vue'

/**
 * Vue DNS Lookup Tool Entry Point
 * 
 * Finds all shortcode mount points on the page and creates
 * independent Vue app instances for each.
 */

// Wait for DOM to be ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeApps)
} else {
  initializeApps()
}

function initializeApps() {
  // Find all DNS lookup shortcode mount points
  const mountPoints = document.querySelectorAll('div[id^="cnfltd-dns-lookup-"]')
  
  if (mountPoints.length === 0) {
    console.warn('[Conflated Domains] No DNS lookup shortcode mount points found')
    return
  }

  console.log(`[Conflated Domains] Found ${mountPoints.length} DNS lookup shortcode(s)`)

  // Create independent Vue app for each mount point
  mountPoints.forEach((element) => {
    try {
      const mountElementId = element.id
      
      // Create app instance
      const app = createApp(App, {
        mountElementId
      })

      // Register Ant Design Vue
      app.use(Antd)

      // Mount to specific element
      app.mount(`#${mountElementId}`)

      console.log(`[Conflated Domains] DNS Lookup app mounted to #${mountElementId}`)
    } catch (error) {
      console.error(`[Conflated Domains] Failed to mount DNS Lookup app to #${element.id}:`, error)
      
      // Display user-friendly error message in mount point
      element.innerHTML = `
        <div style="padding: 1rem; background: #fee; border: 1px solid #fcc; border-radius: 4px; color: #c00;">
          <strong>DNS Lookup Unavailable</strong>
          <p>Unable to load the DNS lookup tool. Please refresh the page or contact support if the problem persists.</p>
        </div>
      `
    }
  })
}
